import axios from 'axios';
import { graphqlUrl } from './graphqlUrl';

const fields = 'id platform latest minimal updated_at';

function platformLiteral(platform) {
  if (!['ANDROID', 'IOS'].includes(platform)) throw new Error('Неизвестная платформа');
  return platform;
}

async function request(query, variables, field) {
  const response = await axios.post(graphqlUrl, { query, variables }, {
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  });
  if (response.data.errors && response.data.errors.length) {
    throw new Error(response.data.errors.map(error => {
      const validation = error.extensions && error.extensions.validation;
      return validation ? Object.values(validation).flat().join('\n') : error.message;
    }).join('\n'));
  }
  const result = response.data.data && response.data.data[field];
  if (result == null) throw new Error('Сервер не вернул данные о версиях приложения');
  return result;
}

export default {
  list() {
    return request(`query { mobileAppVersions { ${fields} } }`, {}, 'mobileAppVersions');
  },
  history(page, first, platform = null) {
    const filter = platform ? `, platform: ${platformLiteral(platform)}` : '';
    return request(`query($page: Int!, $first: Int!) {
      mobileAppVersionHistory(page: $page, first: $first${filter}) {
        data {
          id platform previous_latest previous_minimal latest minimal
          changed_by_id changed_by_name created_at
        }
        paginatorInfo { count currentPage firstItem lastPage total }
      }
    }`, { page, first }, 'mobileAppVersionHistory');
  },
  update({ platform, latest, minimal }) {
    // Inline the allowlisted enum so its GraphQL type name need not be assumed.
    return request(`mutation($latest: String!, $minimal: String!) {
      updateMobileAppVersion(input: {
        platform: ${platformLiteral(platform)}, latest: $latest, minimal: $minimal
      }) { ${fields} }
    }`, { latest, minimal }, 'updateMobileAppVersion');
  }
};
